<template>
    <div class="desktop-login">
        <div class="social">
            <div class="info">Войти через</div>
            <div class="social-desktop">
                <div class="social-btn-wrap">
                    <div class="social-btn fb">
                        <div class="social-btn-icon"></div>
                        <div class="social-btn-text">
                            Войти через <br/>Facebook
                        </div>
                    </div>
                </div>
                <div class="social-btn-wrap">
                    <div class="social-btn ok">
                        <div class="social-btn-icon"></div>
                        <div class="social-btn-text">
                            Войти через <br/>Одноклассники
                        </div>
                    </div>
                </div>
                <div class="social-btn-wrap">
                    <div class="social-btn vk">
                        <div class="social-btn-icon"></div>
                        <div class="social-btn-text">
                            Войти через <br/>Вконтакте
                        </div>
                    </div>
                </div>
                <div class="social-btn-wrap">
                    <div class="social-btn gp">
                        <div class="social-btn-icon"></div>
                        <div class="social-btn-text">
                            Войти через <br/>Google
                        </div>
                    </div>
                </div>
            </div>
            <div class="social-mobile">
                <a>
                    <img src="@/assets/fb.png"/>
                </a>
                <a>
                    <img src="@/assets/ok.png"/>
                </a>
                <a>
                    <img src="@/assets/vk.png"/>
                </a>
                <a>
                    <img src="@/assets/gplus.png"/>
                </a>
            </div>
        </div>
        <div class="login-form-wrap">
            <h3>Или войдите в систему с помощью e-mail или телефона</h3>
            <form class="login-form">
                <Wait v-if="loading">

                </Wait>
                <div v-else>
                <Input v-model="email.value"
                       :error-message="email.error"
                       @input="email.error = null"
                       label="Email"
                       type="email"
                       name="email"
                       required/>
                <Input v-model="password.value"
                       :error-message="password.error"
                       @input="password.error = ''"
                       label="Пароль"
                       type="password"
                       required/>
                </div>
                <div class="opts-row">
                    <div class="remember">
                        <p-check class="p-default p-bigger p-curve" color="info">Запомнить меня</p-check>
                    </div>
                    <div class="forgot">
                        <router-link :to="{ name: 'forgot' }">Не помню пароль</router-link>
                    </div>
                </div>
                <div class="controls-row">
                <Btn danger @click="sendForm">Войти</Btn>
                </div>
            </form>
        </div>
    </div>
    
</template>

<script>
import Vue from 'vue';
import PrettyCheck from 'pretty-checkbox-vue/check';
import { mapActions } from 'vuex';

const actions = ['login', 'validateEmail'];

Vue.component('p-check', PrettyCheck);
export default {
    name: "LoginForm",
    data() {
        return {
            email: {value: '', error: ''},
            password: {value: '', error: ''},
            loading: false,
            clientId: this.$route.params.id,
            state: this.$route.params.state,

        };
    },
    methods: {
        ...mapActions(actions),
        async sendForm(){
            let data = {
                email: this.email.value,
                password: this.password.value,
            };
            if(await this.validateForm(data)){
                this.loading = true;
                let resp = await this.login(data);
                this.loading = false;
                if(resp == 200){
                    //ok
                }
                if(resp == 403){
                    this.password.error = 'Неверный email или пароль.';
                } else {
                    this.password.error = 'Произошла неизвестная ошибка';
                }
            }
        },
        async validateForm(data){
            let errors = 0;

            //email
            if(data.email.trim() == ''){
                this.email.error = 'Введите email'; errors++;
            } else {
                if(!await this.validateEmail(data.email)){
                    this.email.error = 'Введите корректный адрес эл. почты'; errors++;
                }
            }

            //pass
            if(data.password.trim() == ''){
                this.password.error = 'Введите пароль'; errors++;
            }

            return errors == 0;

        },
    },
};
</script>

<style lang="scss">
    @import '../../../node_modules/pretty-checkbox/src/pretty-checkbox';
</style>

<style lang="scss">

    .login-form {
        padding-top: 16px;
    }

    .controls-row {
        display: flex;
        justify-content: center;
        padding-bottom: 8px;
    }

    .social {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        box-sizing: border-box;
        justify-content:    space-between;
        width: 100%;

        .info,
        .social-mobile {
            display: none;
        }
        .social-desktop {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
        }

        @media screen and (max-width: 800px) {
            .social-desktop {
                display: none;
            }
            .info{
                width: 100%;
                text-align: center;
                font-family: "Montserrat", sans-serif;
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 17px;
                color: #98A0A9;
                display: block;
                padding-top: 32px;
            }
            .social-mobile{
                display: block;
                text-align: center;
                width: 100%;
                padding: 16px 0 32px;

                border-bottom: 2px solid #BAC5CB;

                img{
                    margin: 0 10px;
                }
            }
        }
        
        

    }
    
    .social-btn-wrap{
        box-sizing: border-box;
        margin-bottom: 16px;
        flex-basis: 196px;
    }
    .social-btn{
        border-radius: 4px;
        height: 60px;
        width: 100%;
        position: relative;
        cursor: pointer;
        &.fb{
            background-color: #3B5998;
            .social-btn-icon{
                background-image: url(../../assets/fb-lg.png);
                background-size: 25px;
            }
            &:hover{
                background-color: #273964;
            }
        }
        &.vk{
            background-color: #4976A8;
            .social-btn-icon{
                background-image: url(../../assets/vk-lg.png);
                background-size: 30px;
            }
            &:hover{
                background-color: #3f5e8a;
            }
        }
        &.ok{
            background-color: #F18F1B;
            .social-btn-icon{
                background-image: url(../../assets/ok-lg.png);
                background-size: auto 25px;
            }
            &:hover{
                background-color: #ad6515;
            }
        }
        &.gp{
            background-color: #F44336;
            .social-btn-icon{
                background-image: url(../../assets/gplus-lg.png);
                background-size: 20px;
            }
            &:hover{
                background-color: #a5302c;
            }
        }
        .social-btn-icon{
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            content: '';
            height: 100%;
            width: 60px;
            position: relative;
            background-color: rgba(0,0,0,0.3);
            background-repeat: no-repeat;
            background-position: center center;
            display: inline-block;
        }
        .social-btn-text{
            width: 135px;
            vertical-align: top;
            height: 100%;
            text-align: center;
            display: inline-block;
            box-sizing: border-box;
            padding: 8px 0;
            font-weight: bold;
            font-family: "Futura PT", sans-serif;
            font-size: 16px;
            line-height: 21px;
            color: #FFFFFF;
            font-weight: normal;
        }
    }

    .login-form-wrap{
        padding-top: 8px;

        @media screen and (max-width: 800px) {
            padding-top: 32px;
        }

        h3{
            margin-bottom: 32px;
            font-weight: normal;
            font-family: "Futura PT", sans-serif;
            font-size: 16px;
            line-height: 21px;
            color: #3C3C3C;

            @media screen and (max-width: 800px) {
                font-family: "Montserrat", sans-serif;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 17px;
                color: #2A2626;
                margin-bottom: 40px;
            }
        }

        .opts-row{
            display: flex;
            flex-direction: row;
            margin-bottom: 44px;
        }
        .remember{
            flex: 1;
            font-size: 14px;
            
            label {
                font-family: "Futura PT", sans-serif;
                font-size: 14px;
                color: #BAC5CB;
                font-weight: 300!important;
            }
        }
        .forgot{
            flex: 1;
            text-align: right;
            font-size: 10pt;

            @media screen and (max-width: 800px) {
                font-family: "Open Sans";
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
                text-decoration-line: underline;
                color: #3874E0;
            }
        }
        

    }
</style>